import {
  styled
} from 'styled-components'
import { NotificationBase } from '../../base/NotificationBase'

export const NotificationWrapper = styled(NotificationBase)`
    /* Parent
    ------------------------------- */
    padding-right: 13px;
    padding-left: 13px;

    /* Childrens
    ------------------------------- */
    /* Modifiers
    ------------------------------- */
    /* Media queries
    ------------------------------- */
`
